import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FormService {
  iframeHeight: BehaviorSubject<number> = new BehaviorSubject(80)

  constructor() { }
  setIframeHeight(to: number) {
    this.iframeHeight.next(to);
  }
  getIframeHeight(): Observable<number> {
    return this.iframeHeight.asObservable();
  }
}
